import { getStorePreviousUrl } from 'links/login/shared/StorePreviousUrl'
import { useRef } from 'react'

export function useStoredPreviousUrl() {
	const previousUrl = useRef(getStorePreviousUrl())
	return previousUrl.current
}
